import { commentCasePrefix } from './constants';

/**
 * To Comment Case
 */
const toCommentCase = (text: string) => `${commentCasePrefix}${text}`;

export { toCommentCase };
